<script setup>
import { addDays, format } from 'date-fns';
import { DatePicker } from 'v-calendar';
import 'v-calendar/style.css';
import { computed } from 'vue';
import TextInput from 'vue-elements/input/TextInput.vue';
import { useErrorProps, useInputProps, useLabelProps } from '../../../vue-elements/composables/input.js';
import FieldLabel from '../../../vue-elements/field/FieldLabel.vue';
import FieldError from '../../../vue-elements/field/FieldError.vue';

const props = defineProps({
    ...useInputProps,
    ...useLabelProps,
    ...useErrorProps,
    value: Date,
    isValid: Boolean,
    maxDate: Date,
    placement: {
        type: String,
        default: undefined,
    },
});

defineOptions({
    inheritAttrs: false,
});

const minDate = computed(() => addDays(new Date(), 1));

const parsedStartDate = computed(() => {
    if (props.modelValue != null) {
        return new Date(props.modelValue);
    }

    return null;
});

const emit = defineEmits(['update:modelValue', 'update:error']);
const updateModelValue = (value) => {
    emit('update:modelValue', format(value, 'yyyy-MM-dd'));
    emit('update:error', null);
};
</script>

<template>
  <FieldLabel :label="label" />

  <div>
    <date-picker
      locale="nl"
      color="green"
      :model-value="parsedStartDate"
      :popover="{ visibility: 'hover-focus', placement: placement }"
      :max-date="maxDate"
      :min-date="minDate"
      :masks="{input: 'DD-MM-YYYY'}"
      @update:modelValue="updateModelValue($event)"
    >
      <template #default="{ inputValue, inputEvents }">
        <TextInput
          id="start_date"
          ref="input"
          class="datum-input"
          :class="{'is-valid': isValid }"
          :value="inputValue"
          placeholder="dd-mm-jjjj"
          readonly
          show-valid
          v-on="inputEvents"
        />
      </template>
    </date-picker>
  </div>

  <FieldError :error="error" />
</template>
